// Fetch interceptor for Betriebskostenabrechnung (BKA) template injection
// Must run first to wrap fetch before any other code uses it
(function setupTemplateInjectionBKA() {
  // Store the original fetch function
  const originalFetch = window.fetch

  // Replace window.fetch with our wrapper
  window.fetch = async function (url, options = {}) {
    // Convert URL to string if it's a Request object
    const urlString = typeof url === 'string' ? url : url.url || url.toString()

    // Check if this is a GET request to the ops-cost-report endpoint
    const isOpsCostReportRequest =
      urlString.includes('/services/pmp-accounting/api/v1/ops-cost-report/') &&
      (!options.method || options.method === 'GET' || options.method === 'get')

    // Check if this is a PUT request to the template endpoint
    const isTemplatePutRequest =
      urlString.includes('/services/pmp-document/api/v1/documents/template') &&
      (options.method === 'PUT' || options.method === 'put')

    if (isTemplatePutRequest) {
      // Try to parse and modify the body if it exists
      if (options.body) {
        try {
          // Parse the body if it's a string
          let bodyData = options.body
          let bodyNeedsStringify = false
          
          if (typeof options.body === 'string') {
            bodyData = JSON.parse(options.body)
            bodyNeedsStringify = true
          } else if (options.body instanceof FormData) {
            bodyData = 'FormData'
          } else if (options.body instanceof Blob) {
            bodyData = 'Blob'
          }

          // Check if body is an array and process it
          if (Array.isArray(bodyData)) {
            
            let modified = false
            
            // Iterate over array elements
            for (let i = 0; i < bodyData.length; i++) {
              const element = bodyData[i]
              
              // Check if element has pdfDataJsonString property
              if (element && typeof element === 'object' && 'pdfDataJsonString' in element) {
                const pdfDataJsonString = element.pdfDataJsonString
                
                // Check if pdfDataJsonString contains "Betriebskostenabrechnung"
                if (typeof pdfDataJsonString === 'string' && pdfDataJsonString.includes('Betriebskostenabrechnung')) {
                  try {
                    // Get propertyId from lastOpsCostReport in localStorage
                    let propertyDetails = null
                    let propertyOwnerName = null
                    let taxId = null
                    let taxLabel = null
                    let contactSalutation = null
                    try {
                      const lastOpsCostReportStr = localStorage.getItem('lastOpsCostReport')
                      
                      if (lastOpsCostReportStr) {
                        const lastOpsCostReport = JSON.parse(lastOpsCostReportStr)
                        const propertyId = lastOpsCostReport?.propertyId
                        
                        if (propertyId && options.headers) {
                          // Extract Authorization header - handle both Headers object and plain object
                          let authHeader = null
                          if (options.headers instanceof Headers) {
                            authHeader = options.headers.get('authorization')
                          } else if (options.headers.get && typeof options.headers.get === 'function') {
                            authHeader = options.headers.get('authorization')
                          } else if (typeof options.headers === 'object') {
                            authHeader = options.headers['authorization'] || options.headers.authorization
                          }
                          
                          if (authHeader) {
                            // Get the base URL from the current request URL
                            // Handle both absolute and relative URLs
                            let baseUrl
                            try {
                              const urlObj = new URL(urlString)
                              baseUrl = `${urlObj.protocol}//${urlObj.host}`
                            } catch (e) {
                              // If URL is relative, use current window location
                              baseUrl = `${window.location.protocol}//${window.location.host}`
                            }
                            
                            const propertyUrl = `${baseUrl}/services/pmp-accounting/api/v1/properties?propertyId=${propertyId}`
                            const contractsUrl = `${baseUrl}/services/pmp-accounting/api/v1/contracts?propertyId=${propertyId}&type=PROPERTY_OWNER`
                            
                            // Fetch property details and contracts in parallel
                            const [propertyResponse, contractsResponse] = await Promise.all([
                              fetch(
                                propertyUrl,
                                {
                                  headers: {
                                    'Authorization': authHeader,
                                    'Content-Type': 'application/json',
                                  },
                                }
                              ),
                              fetch(
                                contractsUrl,
                                {
                                  headers: {
                                    'Authorization': authHeader,
                                    'Content-Type': 'application/json',
                                  },
                                }
                              )
                            ])
                            
                            if (propertyResponse.ok) {
                              propertyDetails = await propertyResponse.json()
                            }
                            
                            if (contractsResponse.ok) {
                              const contracts = await contractsResponse.json()
                              // Get the first contract's first contact
                              if (Array.isArray(contracts) && contracts.length > 0) {
                                const firstContract = contracts[0]
                                if (firstContract.contacts && Array.isArray(firstContract.contacts) && firstContract.contacts.length > 0) {
                                  const firstContact = firstContract.contacts[0]
                                  propertyOwnerName = firstContact.name
                                  const contactId = firstContact.contactId
                                  
                                  // Fetch contact details to get tax ID
                                  if (contactId) {
                                    const contactUrl = `${baseUrl}/services/pmp-accounting/api/v1/contacts/${contactId}`
                                    const contactResponse = await fetch(
                                      contactUrl,
                                      {
                                        headers: {
                                          'Authorization': authHeader,
                                          'Content-Type': 'application/json',
                                        },
                                      }
                                    )
                                    
                                    if (contactResponse.ok) {
                                      const contact = await contactResponse.json()
                                      
                                      // Store salutation for heading determination
                                      contactSalutation = contact.salutation || null
                                      
                                      // Check if contact is COMPANY type
                                      if (contact.type === 'COMPANY') {
                                        taxId = contact.vatId || null
                                      } else {
                                        // Fetch from ImpowerX
                                        const impowerXUrl = `${baseUrl}/api/impowerX/contacts/tax-number?contactId=${contactId}`
                                        const impowerXResponse = await fetch(
                                          impowerXUrl,
                                          {
                                            headers: {
                                              'Authorization': authHeader,
                                              'Content-Type': 'application/json',
                                            },
                                          }
                                        )
                                        
                                        if (impowerXResponse.ok) {
                                          const impowerXData = await impowerXResponse.json()
                                          taxId = impowerXData.taxNumber || null
                                        }
                                      }
                                      
                                      // Determine label based on tax ID format
                                      if (taxId) {
                                        if (taxId.trim().toUpperCase().startsWith('DE')) {
                                          taxLabel = 'Umsatzsteuer-IdNr.'
                                        } else {
                                          taxLabel = 'Steuernummer'
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    } catch (propertyError) {
                      // Error fetching property details
                    }
                    
                    // Parse the JSON string to get the object
                    const pdfData = JSON.parse(pdfDataJsonString)
                    
                    // Check if it has an html property
                    if (pdfData && typeof pdfData.html === 'string') {
                      let html = pdfData.html
                      
                      // Extract Einheits-Nr. from the main-details table
                      // Pattern: <dt>Einheits-Nr. | Kategorie:</dt><dd>101.01 | Wohnung</dd>
                      const einheitsNrMatch = html.match(/<dt>Einheits-Nr\. \| Kategorie:<\/dt><dd>([^|]+)/)
                      const einheitsNr = einheitsNrMatch ? einheitsNrMatch[1].trim() : null
                      
                      // Extract end-year from the heading
                      // Pattern: Betriebskostenabrechnung  - 01.01.24 - 31.12.24
                      const headingMatch = html.match(/Betriebskostenabrechnung\s*-\s*\d{2}\.\d{2}\.(\d{2})\s*-\s*\d{2}\.\d{2}\.(\d{2})/)
                      const endYear2Digit = headingMatch ? headingMatch[2] : null
                      
                      // Convert 2-digit year to 4-digit year (assuming 2000s)
                      const fullYear = endYear2Digit ? `20${endYear2Digit}` : null
                      
                      // Generate invoice number dynamically in format YYYY-{unitNumber}
                      let invoiceNumber = 'N/A'
                      if (einheitsNr && fullYear) {
                        invoiceNumber = `${fullYear}-${einheitsNr}`
                      }
                      
                      // Check if VAT is relevant - only inject if vatRelevance is NOT "NOT_RELEVANT"
                      const shouldInject = !propertyDetails || propertyDetails.vatRelevance !== 'NOT_RELEVANT'
                      
                      if (shouldInject) {
                        // Use property owner name from contracts, fallback to default
                        let objekteigentümer = propertyOwnerName || ''
                      
                        // Find the closing </dl> tag of the main-details table
                        // We need to insert the new rows before the closing </dl> tag
                        const mainDetailsPattern = /(<dl class="main-details">[\s\S]*?)(<\/dl>)/
                        const match = html.match(mainDetailsPattern)
                        
                        if (match) {
                          // Build the rows to add
                          let rowsToAdd = ''
                          
                          // Only add owner row if objekteigentümer is set
                          if (objekteigentümer) {
                            // Determine heading based on salutation
                            const ownerHeading = contactSalutation === 'MRS' ? 'Objekteigentümerin' : 'Objekteigentümer'
                            rowsToAdd += `<dt>${ownerHeading}:</dt><dd>${objekteigentümer}</dd>`
                          }
                          
                          // Only add tax row if taxId exists
                          if (taxId && taxLabel) {
                            rowsToAdd += `<dt>${taxLabel}:</dt><dd>${taxId}</dd>`
                          }
                          
                          rowsToAdd += `<dt>Rechnungsnummer:</dt><dd>${invoiceNumber}</dd>`
                          
                          // Insert the new rows before the closing </dl> tag
                          html = html.replace(mainDetailsPattern, `$1${rowsToAdd}$2`)
                          
                          // Update the html property
                          pdfData.html = html
                          
                          // Update the element's pdfDataJsonString with the modified JSON
                          element.pdfDataJsonString = JSON.stringify(pdfData)
                          
                          modified = true
                        }
                      }
                    }
                  } catch (parseError) {
                    // Error parsing pdfDataJsonString
                  }
                }
              }
            }
            
            // If we modified the body, update options.body
            if (modified && bodyNeedsStringify) {
              options.body = JSON.stringify(bodyData)
            }
          }
        } catch (error) {
          // Could not parse body
        }
      }
    }

    // Call the original fetch with the (potentially modified) options
    const response = await originalFetch.apply(this, arguments)

    // If this is an ops-cost-report request, save the response to localStorage
    if (isOpsCostReportRequest) {
      try {
        // Clone the response so we can read it without consuming the original
        const clonedResponse = response.clone()
        const responseData = await clonedResponse.json()
        localStorage.setItem('lastOpsCostReport', JSON.stringify(responseData))
      } catch (error) {
        // If response is not JSON or there's an error, try to save as text
        try {
          const clonedResponse = response.clone()
          const responseText = await clonedResponse.text()
          localStorage.setItem('lastOpsCostReport', responseText)
        } catch (textError) {
          // Silently fail if we can't save the response
        }
      }
    }

    return response
  }

})()

